export const MDData = [
  {
    mdName: "Atul Abhyankar",
    mdProject: "",
    mdMarket: "ATC Workday Business Group Lead",
    mdImage: "images/testimonial/md/AtulAbhyankar.png",
    mdVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_l47sh5um/uiConfId/27188232/st/0",
  },
  {
    mdName: "Deepali Dodamani",
    mdProject: "",
    mdMarket: "MD - ATCI NA Midwest H & PS ",
    mdImage: "images/testimonial/md/DeepaliDodamani.png",
    mdVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_rn4s6iwe/uiConfId/27188232/st/0",
  },
  {
    mdName: "Shrikant Sarda",
    mdProject: "",
    mdMarket: "ATCI Canada CG Lead - RES, CMT and FS",
    mdImage: "images/testimonial/md/ShrikantSarda.png",
    mdVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_4bn6b6b3/uiConfId/27188232/st/0",
  },
  {
    mdName: "Sreela Chandran",
    mdProject: "",
    mdMarket: "ATCI Security CTO",
    mdImage: "images/testimonial/md/SomaTiwari.png",
    mdVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_mj4i6o1l/uiConfId/27188232/st/0",
  },
  {
    mdName: "Vasuprad Kanade",
    mdProject: "",
    mdMarket: "ATCI Lead data and ai, Europe CMT and FS",
    mdImage: "images/testimonial/md/VasupradKanade.png",
    mdVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_62igk35y/uiConfId/27188232/st/0",
  },
];
